import React from 'react';
import { VendorChangeRequests } from '../../components/stores/VendorChangeRequests';
import { useAuth } from '../../contexts/AuthContext';

// Procurement executes requests raised by Stores (acknowledge → resolve with the vendor).
// Backend gates PATCH on perm("procurement.po","write") — mirror that via the
// same write_access the rest of the app already reads (not a hardcoded role list),
// so a newly-granted role sees the action without a code change.
// write_access is "all" (string sentinel) for super_admin, else an array of module keys.
export default function VendorChangeRequestsPage() {
  const { user } = useAuth();
  const writeAccess = user?.write_access;
  const canExecute = writeAccess === 'all' || (Array.isArray(writeAccess) && writeAccess.includes('procurement'));
  return (
    <div className="p-6" data-testid="vcr-page">
      <VendorChangeRequests canExecute={canExecute} title="Vendor Change Requests" />
    </div>
  );
}
